import React from "react";
import "./Footer.scss";

function Footer() {
  return (
    <div className="Footer">
      <div className="sectionTwo">
        <div className="socials">
          <div className="trademark">
            <span>&copy; 2025 Lets Fundraise Together LLC. All Rights Reserved</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
